import React from 'react';
import { useTranslation } from 'react-i18next';
import { contactEmail } from '../../data/socialLinks';
import ContactForm from './ContactForm';
import './Contact.css';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <h2 className="section-title">{t('contact.title')}</h2>
        <p className="contact-subtitle">{t('contact.subtitle')}</p>
        <div className="contact-content">
          <ContactForm />
          <div className="contact-divider">
            <span>{t('contact.or')}</span>
          </div>
          <div className="contact-email-wrapper">
            <p className="contact-email-label">{t('contact.emailUs')}</p>
            <a href={`mailto:${contactEmail}`} className="contact-email">
              {contactEmail}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
